import type { DocumentForm } from './document-form'
import type { TrainingDocument } from '~/gql/documents/documents'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '~/components/ui/dialog'
import { documentForm } from './document-form'
import DocumentFields from './DocumentFields'

type IProps = {
  document: TrainingDocument
  sessions: readonly { id: string, name: string }[]
  busy: boolean
  onCancel: () => void
  onSave: (form: DocumentForm) => void
}

/** Modifier les réglages d'un document (#326). Changer de fichier, c'est déposer un nouveau document. */
function DocumentEditDialog({ document, sessions, busy, onCancel, onSave }: IProps) {
  const { t } = useTranslation()
  const [form, setForm] = useState(() => documentForm(document))

  const submit = (event: React.FormEvent) => {
    event.preventDefault()
    if (form.title.trim()) onSave(form)
  }

  return (
    <Dialog open onOpenChange={open => !open && onCancel()}>
      <DialogContent className="sm:max-w-lg">
        <form onSubmit={submit} className="flex flex-col gap-4">
          <DialogHeader>
            <DialogTitle>{document.title}</DialogTitle>
          </DialogHeader>
          <DocumentFields value={form} onChange={setForm} sessions={sessions} />
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onCancel}>{t('common.cancel')}</Button>
            <Button type="submit" disabled={!form.title.trim() || busy}>{t('common.save')}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}

export default DocumentEditDialog
